/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ContractApplicationAttachmentFile model module.
 * @module model/ContractApplicationAttachmentFile
 * @version 1.0.0
 */
class ContractApplicationAttachmentFile {
    /**
     * Constructs a new <code>ContractApplicationAttachmentFile</code>.
     * @alias module:model/ContractApplicationAttachmentFile
     */
    constructor() { 
        
        ContractApplicationAttachmentFile.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ContractApplicationAttachmentFile</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ContractApplicationAttachmentFile} obj Optional instance to populate.
     * @return {module:model/ContractApplicationAttachmentFile} The populated <code>ContractApplicationAttachmentFile</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ContractApplicationAttachmentFile();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('contract_application_id')) {
                obj['contract_application_id'] = ApiClient.convertToType(data['contract_application_id'], 'Number');
            }
            if (data.hasOwnProperty('object_storage_path')) {
                obj['object_storage_path'] = ApiClient.convertToType(data['object_storage_path'], 'String');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('attachment_file_url')) {
                obj['attachment_file_url'] = ApiClient.convertToType(data['attachment_file_url'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ContractApplicationAttachmentFile</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ContractApplicationAttachmentFile</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['object_storage_path'] && !(typeof data['object_storage_path'] === 'string' || data['object_storage_path'] instanceof String)) {
            throw new Error("Expected the field `object_storage_path` to be a primitive type in the JSON string but got " + data['object_storage_path']);
        }
        // ensure the json data is a string
        if (data['attachment_file_url'] && !(typeof data['attachment_file_url'] === 'string' || data['attachment_file_url'] instanceof String)) {
            throw new Error("Expected the field `attachment_file_url` to be a primitive type in the JSON string but got " + data['attachment_file_url']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
ContractApplicationAttachmentFile.prototype['id'] = undefined;

/**
 * @member {Number} contract_application_id
 */
ContractApplicationAttachmentFile.prototype['contract_application_id'] = undefined;

/**
 * @member {String} object_storage_path
 */
ContractApplicationAttachmentFile.prototype['object_storage_path'] = undefined;

/**
 * @member {Date} created_at
 */
ContractApplicationAttachmentFile.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
ContractApplicationAttachmentFile.prototype['updated_at'] = undefined;

/**
 * @member {String} attachment_file_url
 */
ContractApplicationAttachmentFile.prototype['attachment_file_url'] = undefined;






export default ContractApplicationAttachmentFile;

